<template>
  <div>
    <h2>{{ $t('message.credit.incomeAndMonthlyExpenses.heading') }}</h2>
    <p>{{ $t('message.credit.incomeAndMonthlyExpenses.subHeading') }}</p>
    <MobialisFormWithValidation
      @onValidate="submit"
      novalidate
      v-slot="{ errors }"
      v-av-analytics-form-submit="{ elementText: $t('message.common.continue') }"
    >
      <div class="row align-items-end">
        <div class="col-12 col-sm-7">
          <div v-if="incomeDetailsMethod === 'hourly'">
            <mobialis-text-input-with-validation
              rules="required"
              :label="$t('message.credit.incomeAndMonthlyExpenses.grossIncome.label')"
              :helper="$t('message.credit.incomeAndMonthlyExpenses.grossIncome.helper')"
              v-model="hourlyWage"
              :mask-type="dollarMaskType"
              inputmode="numeric"
              vid="hourlyWage"
              data-cy="hourlyWage"
            ></mobialis-text-input-with-validation>
          </div>
          <div v-else-if="incomeDetailsMethod === 'monthly'">
            <mobialis-text-input-with-validation
              rules="required|max_value:8333333"
              :label="$t('message.credit.incomeAndMonthlyExpenses.grossIncome.label')"
              :helper="$t('message.credit.incomeAndMonthlyExpenses.grossIncome.helper')"
              v-model="monthlyIncome"
              :mask-type="dollarMaskType"
              inputmode="numeric"
              vid="monthlyIncome"
              data-cy="monthlyIncome"
            ></mobialis-text-input-with-validation>
          </div>
          <div v-else>
            <mobialis-text-input-with-validation
              rules="required|max_value:99999999"
              :label="$t('message.credit.incomeAndMonthlyExpenses.grossIncome.label')"
              :helper="$t('message.credit.incomeAndMonthlyExpenses.grossIncome.helper')"
              v-model="annualIncome"
              :mask-type="dollarMaskType"
              inputmode="numeric"
              vid="annualIncome"
              data-cy="annualIncome"
            ></mobialis-text-input-with-validation>
          </div>
        </div>
        <div
          class="col-12 col-sm-5"
          :class="{
            'pb-sm-4':
              (errors.annualIncome && errors.annualIncome[0]) ||
              (errors.monthlyIncome && errors.monthlyIncome[0]) ||
              (errors.hourlyWage && errors.hourlyWage[0]),
          }"
        >
          <mobialis-selection-input-with-validation
            rules="required"
            :label="$t('message.credit.incomeAndMonthlyExpenses.incomeFrequency.label')"
            vid="incomeFrequency"
            :options="incomeDetailsMethodOptions"
            v-model="incomeDetailsMethod"
          ></mobialis-selection-input-with-validation>
        </div>
      </div>
      <div class="row mb-4">
        <mobialis-text-input-with-validation
          v-if="incomeDetailsMethod === 'hourly'"
          class="col-12 col-sm-7"
          rules="required"
          :label="$t('message.credit.incomeAndMonthlyExpenses.incomeFrequency.week')"
          v-model="hoursPerWeek"
          mask-type="naturalNumbers"
          inputmode="numeric"
          pattern="[0-9]*"
          vid="hoursPerWeek"
          data-cy="hoursPerWeek"
        ></mobialis-text-input-with-validation>
        <mobialis-text-input-with-validation
          rules="required|max_value:9999"
          class="col-12 col-sm-7"
          :label="$t('message.credit.incomeAndMonthlyExpenses.rentMortgage.label')"
          :helper="$t('message.credit.incomeAndMonthlyExpenses.rentMortgage.helper')"
          :mask-type="dollarMaskType"
          inputmode="numeric"
          v-model="monthlyPayment"
          vid="monthlyPayment"
          data-cy="monthlyPayment"
        ></mobialis-text-input-with-validation>
      </div>
      <template v-if="displayDownPayment">
        <h3 class="mt-4 mb-3">{{ $t('message.credit.incomeAndMonthlyExpenses.downPayment.heading') }}</h3>
        <div class="row mb-4">
          <mobialis-text-input-with-validation
            class="col-12 col-sm-7"
            :mask-type="dollarMaskType"
            inputmode="numeric"
            pattern="[0-9]*"
            :label="$t('message.credit.incomeAndMonthlyExpenses.downPayment.label')"
            v-model="downPayment"
            vid="downPayment"
            data-cy="downPayment"
          ></mobialis-text-input-with-validation>
        </div>
      </template>
      <mobialis-button type="submit" class="mt-4 mb-1" data-cy="continue">{{
        $t('message.common.continue')
      }}</mobialis-button>
      <p class="text-center small my-0">
        {{ $t('message.credit.disclaimer.noAffectScore') }}
      </p>
    </MobialisFormWithValidation>
  </div>
</template>

<script>
import { IncomeExpenses } from '@/mixins';

export default {
  name: 'IncomeExpenseForm',
  mixins: [IncomeExpenses],
  computed: {
    displayDownPayment() {
      return !!this.$store.state.business.info.creditSettings.prequalificationConsumerInventoryMatchingEnabled;
    },
  },
  methods: {
    async submit(isValid) {
      if (!isValid) {
        return;
      }
      this.$store.commit('SET_LOADING', true);
      this.updateIncome();
      this.updateMortgageExpense();
      if (this.displayDownPayment) {
        this.updateDownPayment();
      }
      try {
        await this.$store.dispatch('lead/updateLead');
        this.$router.push({
          name: `other-monthly-expenses-${this.baseRoute}`,
        });
      } catch (err) {
        this.$log('Error in IncomeExpenseForm - Update Lead: ', err);
        this.$router.push({ name: `credit-in-error-${this.baseRoute}` });
      } finally {
        this.$store.commit('SET_LOADING', false);
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
